<template>
  <div class="row" v-if="ready">
    <div class="col-12">
      <q-select
        v-if="serverData && serverData.length"
        v-model="qbProdservName"
        name="qbProdservName"
        :options="serverData | qOptions('name', 'name')"
        hide-underline
        inverted-light
        :color="inputBgColor"
        @input="updateParent"
        filter
        autofocus-filter
      />
    </div>
  </div>
</template>
<script>
import colorsMixin from '../../mixins/colors'
import environmentMixin from '../../mixins/environment'
import {openURL} from 'quasar'

export default {
  name: 'QuickbooksProductService',
  mixins: [colorsMixin, environmentMixin],
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // qbProdservName: undefined,
      qbProdservName: '',
      ready: false,
      loading: false,
      serverData: []
    }
  },
  methods: {
    externalLink (url) {
      let finalUrl = this.quickbooksBaseUrl + url
      openURL(finalUrl)
    },
    updateParent (value) {
      const selectedOption = this.serverData.filter(option => option.name === value)
      if (selectedOption && selectedOption[0]) {
        // console.log(selectedOption)
        this.$emit('manual-update', 'qbProdservId', parseInt(selectedOption[0].id))
      }
      this.$emit('manual-update', this.column.field, value)
    },
    handleSelect (id) {
      // console.log('handleSelect', id)
      this.qbProdservName = parseInt(id)
      this.modalOpen = false
      this.updateParent(parseInt(id))
    },
    handleAdd () {
    },
    handleMatch () {
      this.request({
        pagination: this.serverPagination,
        filter: this.filter
      })
      this.modalOpen = true
    },
    async request () {
      this.loading = true
      try {
        const {data} = await this.$axios.get('/api/quickbooksaccounting/productservice/list')
        if (data) {
          this.serverData = data
          this.loading = false
        } else {
          this.$q.notify({
            message: 'Error fetching QuickBook Records 1'
          })
          this.loading = false
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching QuickBook Records 2'
        })
        this.loading = false
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        this.qbProdservName = v
      },
      immediate: true
    }
  },
  async created () {
    await this.request()
    this.ready = true
  }
}
</script>
